import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { SelectedPlayersProvider } from './contexts/SelectedPlayersContext';
import AppRoutes from './components/AppRoutes';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <SelectedPlayersProvider>
        <Router>
          <div className='app'>
            <AppRoutes />
          </div>
        </Router>
      </SelectedPlayersProvider>
    </AuthProvider>
  );
}

export default App;
